import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KaddyChainAudioResponsePair } from '../data/kadychain';
import { Options, Source } from '../data/video-js-options';
import { DataService } from '../data/data.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-kadychain-chat-viewer',
  templateUrl: './kadychain-chat-viewer.component.html',
  styleUrl: './kadychain-chat-viewer.component.css'
})
export class KadychainChatViewerComponent implements OnInit {
  [x: string]: any;
  @Input() selectedConversationResponsePair: KaddyChainAudioResponsePair;
  @Input() studentID: number;
  @Input() botName:string;
  @Output() onVideoLoadStarted = new EventEmitter<string>();
  urlActorString: string;
  urlStudentString: string;
  actorThumbnailUrl: any;
  isLoadingStudentThumbnail: boolean;
  selectedVideoURL: any;
  showStudentVideoPlayer: boolean;
  ShowNoAudioStudentTxt: boolean;
  ShowNoAudioBotTxt: boolean;
  loadingStudentVideo: boolean;
  showBotVideoPlayer: boolean;
  selectedVideoHtmlType: string = 'audio/mp3';
  optionsForStudentVideo: Options;
  optionsForBotVideo: Options;
  promptText: string;

  constructor(
    protected sanitizer: DomSanitizer,
    protected dataService: DataService
  ) { }
  ngOnInit() {
    console.log(this.selectedConversationResponsePair);
    if (this.selectedConversationResponsePair.StudentResponse != null&&this.selectedConversationResponsePair.StudentResponse.artifactID!=null) {
      this.dataService.getArtifactString(this.studentID, this.selectedConversationResponsePair.StudentResponse.artifactID).subscribe(x => {
        this.studentVideoURL = this.getStudentArtifactVideoBytes(x);
        this.loadStudentVideoPlayer();
      });
    }
    else {
      this.ShowNoAudioStudentTxt = true;
    }

    if (this.selectedConversationResponsePair.BotResponseAudio != null) {
      this.dataService.getArtifactString(this.studentID, this.selectedConversationResponsePair.BotResponseAudio.artifactID).subscribe(x => {
        this.actorThumbnailUrl = this.getActorArtifactVideoBytes(x);
        this.loadActorVideoPlayer();
      });
    } else {
      this.ShowNoAudioBotTxt = true;
    }

  }
  loadActorVideoPlayer() {

    this.optionsForBotVideo = new Options();
    this.optionsForBotVideo.height = "150%";
    this.optionsForBotVideo.width = "auto";
    this.optionsForBotVideo.sources = new Array();
    this.optionsForBotVideo.muted = false;
    this.optionsForBotVideo.poster = "assets/voiceonly_thumbnail.png"
    this.optionsForBotVideo.audioPosterMode = true;
    var source = new Source();
    source.src = this.urlActorString;
    source.type = this.selectedVideoHtmlType;
    this.optionsForBotVideo.sources.push(source);
    this.showBotVideoPlayer = true;
  }
  loadStudentVideoPlayer() {

    this.optionsForStudentVideo = new Options();
    this.optionsForStudentVideo.height = "150%";
    this.optionsForStudentVideo.width = "auto";
    this.optionsForStudentVideo.sources = new Array();
    this.optionsForStudentVideo.muted = false;
    this.optionsForStudentVideo.audioPosterMode = true;
    this.optionsForStudentVideo.poster = "assets/voiceonly_thumbnail.png"
    var source = new Source();
    source.src = this.urlStudentString;
    source.type = this.selectedVideoHtmlType;
    this.optionsForStudentVideo.sources.push(source);
    this.showStudentVideoPlayer = true;
  }
  getActorArtifactVideoBytes(artifactString: string): SafeResourceUrl {
    if (artifactString) {
      var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(artifactString)], { type: this.studentVideoHtmlType }));
      this.urlActorString = unsafeURL;
      return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
    }
    else {
      return null;
    }
  }
  getStudentArtifactVideoBytes(artifactString: string): SafeResourceUrl {
    if (artifactString) {
      var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(artifactString)], { type: this.studentVideoHtmlType }));
      this.urlStudentString = unsafeURL;
      return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
    }
    else {
      return null;
    }
  }

  convertEncodedDataToBinary(base64): Uint8Array {
    if (base64) {
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));
      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
    }
    return array;
  }

}
